import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const Androidbuss = () => {
  return (
    <div className="androidbuss tekrevol_dark_bg p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2>
              Why Choose TekRevol as Your <span>On-Demand App</span> Development
              Company?
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <p>
              Opting for TekRevol as your on-demand mobile app development
              company benefits you with new-age technologies, USA’s most
              sought-after mobile application developers, and a refined process
              – safe hands for your transformative project. Apart from expert
              core app development, we engage our business acumen, diverse
              industry prowess, and proven product growth strategies to help you
              build something more than an app – a complete experience based on
              user personas, a secure expansion to the business’s digital
              ecosystem, and an interactive platform that grows with you.
            </p>
          </Col>
        </Row>
        <Row className="h-100 buss-padd">
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Seamless App Launch</h6>
                <p>
                  Launch your customized app effortlessly on major app stores.
                  No technical know-how required—just instant deployment and
                  results.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Drive Customer Engagement</h6>
                <p>
                  Keep customers hooked with strategic push notifications. Boost
                  sales and reduce stress with a streamlined engagement
                  strategy.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Rescue Lost Opportunities</h6>
                <p>
                  Recover abandoned carts and missed sales. Send personalized
                  reminders and offers to turn potential losses into profits.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Boost Brand Loyalty</h6>
                <p>
                  Reward loyal customers with exclusive perks and incentives.
                  Encourage repeat purchases and build lasting relationships.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Tap into New Markets</h6>
                <p>
                  Use on-demand apps to expand into new markets or geographic
                  regions. Reach a wider audience, localize offerings, and
                  capture new markets.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Innovate for Growth</h6>
                <p>
                  Constantly innovate with on-demand apps. Create unique
                  experiences, solve problems, and unlock new revenue streams to
                  drive growth and profitability.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Androidbuss;
